import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import AddWordingsState from './AddNewWordingModal/addWordingContext/addWordingsState/AddWordingsState';
import AddWordingModal from './AddNewWordingModal/AddWordingModal';
import React, { useCallback, useContext } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ILocalizationContext, LocalizationContext } from '../../../../localizationState/localizationContext';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { changeTypeOfModalWindow, removeWording, deleteWordingData, typeOfModalWindow } =
		useContext<ILocalizationContext>(LocalizationContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	const handleDelete = () => {
		if (deleteWordingData) {
			removeWording(deleteWordingData.groupId, deleteWordingData.wordingId);
		}
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleDelete}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteWording"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
			{/* <AddWordingsState> // TODO KMD-8157 (delete all logic later)
				<AddWordingModal isVisible={typeOfModalWindow === 'addWording'} onClose={handleCloseModal} />
			</AddWordingsState> */}
		</div>
	);
};

export default ModalWindows;
